import {
  lettersNumbersSpacesPattern,
  lettersNumbersDotDashApostropheSpacePattern,
} from 'jl-design-system/form/regex';

export const controlCharPattern = '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F';

export const restrictInputLettersNumbersSpaces = (value = '') => {
  if (typeof value !== 'string') {
    return '';
  }
  const regex = new RegExp(`[^${lettersNumbersSpacesPattern}]`, 'g');
  return value.replace(regex, '');
};

export const restrictInputLettersNumbersDotDashApostropheSpaces = (value = '') => {
  if (typeof value !== 'string') {
    return '';
  }
  const regex = new RegExp(`[^${lettersNumbersDotDashApostropheSpacePattern}]`, 'g');
  return value.replace(regex, '');
};

export const restrictInputExcludeControlChars = (value = '') => {
  if (typeof value !== 'string') {
    return '';
  }
  const regex = new RegExp(`[${controlCharPattern}]`, 'g');
  return value.replace(regex, '');
};
